<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item >查看商品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth">
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品名称" prop="name">
              <span>{{addForm.name}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品封面" prop="img">
              <div class="img-list">
                <!-- <img
                  class="upload-img"
                  :src="item"
                  v-for="(item,index) in addForm.imgs"
                  :key="index"
                  alt
                />-->
                <el-image
                  class="upload-img"
                  :src="item"
                  v-for="(item,index) in addForm.imgs"
                  :key="index"
                  :preview-src-list="addForm.imgs"
                ></el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="所属科目" prop="subjectId">
              <span>{{addForm.subjectCourseName}}</span>
            </el-form-item>
            <el-form-item label="是否上架" prop="sell">
              <span>{{addForm.sell==1?'上架':'下架'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="原价" prop="originalPrice">
              <span>{{addForm.originalPrice}}元</span>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="折后价" prop="price">
              <span>{{addForm.price}}元</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="有效天数" prop="validDay">
              <span>{{addForm.validDay?addForm.validDay+'天':'不限'}}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="包含教材" prop>
              <span>{{addForm.material?addForm.material:'无'}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="库存" prop="stock">
              <span>{{addForm.stock}}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="初始销量" prop="sellCount">
              <span>{{addForm.sellCount?addForm.sellCount:0}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="上架时间" prop="onTime">
              <span>{{addForm.onTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="下架时间" prop="offTime">
              <span>{{addForm.offTime?addForm.offTime:'不限'}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="课程摘要">
              <span>{{addForm.summary?addForm.summary:'无'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品介绍" prop="detail">
              <span v-html="ueTtext?ueTtext:'无'"></span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      postDisabled: false,
      offTimeDisabled: false,
      validDayDisabled: false,
      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      ueTtext: "",
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      addTeacherList: [],
      offTimeRadio: null,
      validDayRadio: null,

      addForm: {
        name: "",
        imgs: [],
        img: "",
        subjectId: "",
        originalPrice: "",
        price: "",
        validDay: "",
        material: "",
        sell: 1,
        stock: "",
        sellCount: "",
        onTime: "",
        offTime: "",
        summary: "",
        detail: ""
      },
      formLabelWidth: "80px",

      subjectTreeList: [], //科目
      courseIds: [], //科目
      discount: "",
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      }
    };
  },
  methods: {
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGoodsInfo() {
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.id
        })
        .then(result => {
          this.addForm = result.data;
          this.addForm.imgs = result.data.img.split(",");
          console.log(this.addForm.imgs);

          this.ueTtext = this.addForm.detail;
          this.addForm.sell = String(this.addForm.sell);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getGoodsInfo();
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.img-list {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  align-items: center;
  .select {
    opacity: 0.6;
    background: #333;
  }
  .main-img {
    margin: 0 10px;
    text-align: center;
    font-size: 14px;
    margin-top: -20px;
    width: 160px;
    height: 40px;
    line-height: 40px;
  }
  .upload-img {
    display: inline-block;
    width: 160px;
    height: 100px;
    border-radius: 4px;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
    padding: 0px;
  }
  .upload-img:first-child {
    display: inline-block;
    width: 160px;
    height: 100px;
    border-radius: 4px;
    margin: 0 0px;
    position: relative;
    cursor: pointer;
    padding: 0px;
  }
  .delete-img {
    top: -5px;
    right: -10px;
    // width: 160px;
    // height: 100px;
    border-radius: 4px;
    position: absolute;
    z-index: 12;
    cursor: pointer;
    .icons {
      color: red;
      z-index: 1343;
      font-size: 24px;
    }
  }
}
.upload-div {
  display: flex;
  flex-direction: row;

  .upload-content {
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
      line-height: 32px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
      margin-left: 5px;
    }
  }
}
.el-radio + .el-radio {
  margin-left: 0px !important;
}
.margin-left {
  margin: 0px !important;
}
.el-form-item {
  margin-bottom: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/goodsInfo/goGoodsInfo.vue